import { render, staticRenderFns } from "./m-section-store.vue?vue&type=template&id=023a3862&scoped=true&"
import script from "./m-section-store.vue?vue&type=script&lang=js&"
export * from "./m-section-store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023a3862",
  null
  
)

export default component.exports